/** @format */

import { createReducer, on } from '@ngrx/store';
import { ScoreCardState } from '@pdp/data-access/interfaces';

import { scoreCardEligibilitySkuLoadedSuccess } from './scorecard.actions';

export const initialState: ScoreCardState = {};

export const scoreCardReducer = createReducer(
  initialState,
  on(scoreCardEligibilitySkuLoadedSuccess, (state, { skuData }) => ({
    ...state,
    skuData,
  })),
);
